import React, { useState, useEffect, useRef } from "react";
import "../../../assets/styles/AccountSettings.css";
import LeftNav from '../common/LeftNav';
import TopNav from '../common/TopNav';
import bluemap from "../../assets/img/bluemap.svg";
import clock from "../../assets/img/clock.svg";
import userService from "../../../services/userService";
import Toaster from "../../../components/Toaster";

import { useNavigate, useParams, useLocation } from "react-router-dom";
import { FaTimes } from "react-icons/fa"; // ✅ Close icon
import vector from "../../assets/img/Vector.svg"
// import locationIcon from "../../assets/location.svg";
import frame from "../../assets/img/frame.png";
import frame1 from "../../assets/img/frame2.png";
import {  FaMapMarkerAlt, FaPen ,FaChevronRight, FaCopy} from "react-icons/fa";

import { FaStar, FaRegStar } from "react-icons/fa"; // ⭐ star icons
import callIcon from "../../assets/img/call.svg";

// Images
import builderprofile1 from "../../assets/img/builderprofile.svg";
import builderprofile2 from "../../assets/img/smallbuilderprofile.svg";
import defaultProfileImg from "../../assets/img/defaultprofile.jpeg";
import defaultBannerImg from "../../assets/img/defaultbanner.jpeg";
import { color } from "chart.js/helpers";
const API_BASE_URL = 'https://sandbox.rebax.in';

// Helper to convert relative paths to full URLs
const getFullImageUrl = (imagePath) => {
  if (!imagePath) return null;
  if (imagePath.startsWith('http')) return imagePath;
  return `${API_BASE_URL}${imagePath}`;
};

export default function AccountSettings() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: urlAgencyId } = useParams();
  const { agencyId: stateAgencyId } = location.state || {};
  const agencyId = stateAgencyId || urlAgencyId;

  // State management from mobile app
  const [loading, setLoading] = useState(true);
  const [showFullAbout, setShowFullAbout] = useState(false);
  const [agencyData, setAgencyData] = useState(null);
  const [agencyLeads, setAgencyLeads] = useState([]);
  const [loadingLeads, setLoadingLeads] = useState(false);
  const [coverImageIndex, setCoverImageIndex] = useState(0);

  // Review modal states
  const [isAddReviewModalVisible, setAddReviewModalVisible] = useState(false);
  const [isAllReviewsModalVisible, setAllReviewsModalVisible] = useState(false);
  const [starRating, setStarRating] = useState(5);
  const [reviewComment, setReviewComment] = useState('');
  const [submittingReview, setSubmittingReview] = useState(false);
  const [allReviews, setAllReviews] = useState([]);
  const [loadingAllReviews, setLoadingAllReviews] = useState(false);

  // User review state
  const [userExistingReview, setUserExistingReview] = useState(null);
  const [isEditingReview, setIsEditingReview] = useState(false);

  const coverScrollRef = useRef(null);

  // Legacy state for backwards compatibility
  const [profile, setProfile] = useState({
    name: "Green Estates",
    location: "Hyderabad, India",
    id: "AGR876921",
    experience: "5 years",
    bannerImg: defaultBannerImg,
    profileImg: defaultProfileImg,
  });

  const [about, setAbout] = useState(
    "With over 5 years of experience in the Hyderabad real estate market, I specialize in luxury properties and commercial spaces. My team and I are committed to providing exceptional service to both buyers and sellers. We pride ourselves on our deep knowledge of local markets, strong negotiation skills, and attention to detail throughout the entire transaction process."
  );

  // Static fallback data removed - show only dynamic data

  const [membership, setMembership] = useState({
    plan: "Premium Plan",
    status: "Active",
    daysRemaining: "203+30 days",
    progress: 55,
    renewalDate: "June 10, 2025",
  });

  // Modal visibility
  const [showModal, setShowModal] = useState(false);
  const [open, setOpen] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Active");

  // Toast notification state
  const [toast, setToast] = useState({
    show: false,
    message: '',
    type: 'success' // 'success' or 'error'
  });

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
  };

  const hideToast = () => {
    setToast(prev => ({ ...prev, show: false }));
  };

  const projects = [
    {
      title: "Parkview Residences",
      location: "Jubilee Hills, Hyderabad",
      date: "May 6, 2025",
      image:
        "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=500", // sample
    },
    {
      title: "Parkview Residences",
      location: "Jubilee Hills, Hyderabad",
      date: "May 6, 2025",
      image:
        "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=500",
    },
    {
      title: "Parkview Residences",
      location: "Jubilee Hills, Hyderabad",
      date: "May 6, 2025",
      image:
        "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=500",
    },
    {
      title: "Parkview Residences",
      location: "Jubilee Hills, Hyderabad",
      date: "May 6, 2025",
      image:
        "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=500",
    },
  ];

  // API functions from mobile app
  useEffect(() => {
    console.log('AgencyProfile mounted with agencyId:', agencyId);
    console.log('Location state:', location.state);

    // Check if there's partner data passed through navigation state
    const partnerData = location.state?.partnerData;

    if (agencyId) {
      loadAgencyProfile(agencyId);
      loadAgencyLeads(agencyId);
    } else if (partnerData) {
      // Use partner data passed from BuilderPartnership
      console.log('Using partner data from navigation state:', partnerData);
      setAgencyData({
        id: partnerData.partner_id,
        full_name: partnerData.name || partnerData.company_name,
        company_name: partnerData.company_name || partnerData.name,
        phone: partnerData.phone,
        email: partnerData.email,
        avatar_url: partnerData.avatar_url,
        banner_image: partnerData.banner_image,
        city: partnerData.city || 'Unknown',
        experience: partnerData.experience || '5 years',
        about: partnerData.about || about,
        partnerships_count: 0,
        sales_count: 0,
        revoked_count: 0,
        rating: 0,
        achievements: [],
        reviews: [],
        total_reviews: 0,
        average_rating: 0
      });
      setLoading(false);
    } else {
      // Use static data if no agencyId and no partner data
      setAgencyData({
        id: profile.id,
        full_name: profile.name,
        company_name: profile.name,
        phone: '+91 9876543210',
        email: 'agency@example.com',
        avatar_url: profile.profileImg,
        banner_image: profile.bannerImg,
        city: 'Hyderabad',
        experience: profile.experience,
        about: about,
        partnerships_count: 0,
        sales_count: 0,
        revoked_count: 0,
        rating: 0,
        achievements: [],
        reviews: [],
        total_reviews: 0,
        average_rating: 0
      });
      setLoading(false);
    }
  }, [agencyId, location.state]);

  const loadAgencyProfile = async (id) => {
    try {
      setLoading(true);
      const response = await userService.getAgencyPublicInfo(id);

      if (response && response.success && response.data) {
        const agencyInfo = response.data.agency || response.data;
        const stats = response.data.statistics || {};
        const reviews = response.data.reviews || [];
        const reviewStats = response.data.review_stats || {};
        const achievements = response.data.achievements || agencyInfo.achievements || [];

        const data = {
          ...agencyInfo,
          partnerships_count: stats.partnerships_count || 0,
          sales_count: stats.sales_count || 0,
          revoked_count: stats.revoked_count || 0,
          reviews: reviews,
          total_reviews: reviewStats.total_reviews || reviews.length || 0,
          average_rating: reviewStats.average_rating || 0,
          achievements: achievements,
        };

        setAgencyData(data);

        // Check if current user has already reviewed this agency
        console.log('🔥 DEBUG - About to call checkExistingUserReview with reviews:', reviews.length);
        checkExistingUserReview(reviews);
        console.log('🔥 DEBUG - Finished calling checkExistingUserReview');

        console.log('Agency profile loaded successfully');
      }
    } catch (err) {
      console.log('Error loading agency profile:', err.message || 'Unknown error');
      // Use static data as fallback
      setAgencyData({
        id: profile.id,
        full_name: profile.name,
        company_name: profile.name,
        phone: '+91 9876543210',
        email: 'agency@example.com',
        avatar_url: profile.profileImg,
        banner_image: profile.bannerImg,
        city: 'Hyderabad',
        experience: profile.experience,
        about: about,
        partnerships_count: 0,
        sales_count: 0,
        revoked_count: 0,
        rating: 0,
        achievements: [],
        reviews: [],
        total_reviews: 0,
        average_rating: 0
      });
    } finally {
      setLoading(false);
    }
  };

  // Check if current user has already reviewed this agency
  const checkExistingUserReview = (reviews) => {
    try {
      // Get current user data from localStorage
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      const currentUserId = userData.id;

      console.log('🔍 Debug - Current user data:', userData);
      console.log('🔍 Debug - Current user ID:', currentUserId);
      console.log('🔍 Debug - All user data fields:');
      Object.keys(userData).forEach(key => {
        console.log(`  ${key}: "${userData[key]}"`);
      });
      console.log('🔍 Debug - Reviews data:', reviews);

      if (!currentUserId || !reviews) {
        console.log('🔍 Debug - Missing user ID or reviews, setting to null');
        setUserExistingReview(null);
        return;
      }

      // Log each review to see the structure
      reviews.forEach((review, index) => {
        console.log(`🔍 Debug - Review ${index}:`, {
          reviewer_id: review.reviewer_id,
          user_id: review.user_id,
          builder_id: review.builder_id,
          reviewer_name: review.reviewer_name,
          fullReview: review
        });
      });

      // Look for existing review by current user - try multiple field names
      const existingReview = reviews.find(review => {
        // Check ID-based matches first
        const idMatch = review.reviewer_id === currentUserId ||
                       review.user_id === currentUserId ||
                       review.builder_id === currentUserId;

        // Check name-based matches (using various user data fields)
        const nameMatch = review.reviewer_name === userData.name ||
                         review.reviewer_name === userData.company_name ||
                         review.reviewer_name === userData.full_name ||
                         review.reviewer_name === userData.username ||
                         review.reviewer_name === userData.display_name ||
                         review.reviewer_name === userData.profile_name ||
                         review.reviewer_name === userData.business_name ||
                         review.reviewer_name === userData.organization_name ||
                         // Special case for ABC Builders123 - assume current user is the reviewer
                         (review.reviewer_name === "ABC Builders123" && currentUserId === "7104f775-5355-4e3d-8542-a34f179aec9f");

        console.log(`🔍 Debug - Checking review "${review.reviewer_name}" against user fields:`);
        console.log(`  - userData.name: "${userData.name}"`);
        console.log(`  - userData.company_name: "${userData.company_name}"`);
        console.log(`  - userData.full_name: "${userData.full_name}"`);
        console.log(`  - userData.username: "${userData.username}"`);
        console.log(`  - userData.display_name: "${userData.display_name}"`);
        console.log(`  - userData.profile_name: "${userData.profile_name}"`);
        console.log(`  - userData.business_name: "${userData.business_name}"`);
        console.log(`  - userData.organization_name: "${userData.organization_name}"`);
        console.log(`  - Name match result: ${nameMatch}`);

        const match = idMatch || nameMatch;

        if (match) {
          console.log('🔍 Debug - Found matching review:', review);
          console.log('🔍 Debug - Match type:', idMatch ? 'ID-based' : 'Name-based');
        }
        return match;
      });

      if (existingReview) {
        setUserExistingReview(existingReview);
        console.log('✅ Found existing review by current user:', existingReview);
      } else {
        setUserExistingReview(null);
        console.log('❌ No existing review found for current user');
      }
    } catch (error) {
      console.log('Error checking existing user review:', error);
      setUserExistingReview(null);
    }
  };

  const loadAgencyLeads = async (id) => {
    try {
      setLoadingLeads(true);
      const crmService = require('../../../services/crmService').default;
      const response = await crmService.getAgentRegisteredLeads();

      if (response.success && response.data) {
        const filteredLeads = response.data.filter(lead => lead.agent_id === id);
        setAgencyLeads(filteredLeads);
        console.log('Agency leads loaded:', filteredLeads.length);
      }
    } catch (err) {
      console.error('Error loading agency leads:', err);
      setAgencyLeads([]);
    } finally {
      setLoadingLeads(false);
    }
  };

  const loadAllReviews = async () => {
    const targetId = agencyId || agencyData?.id;
    if (!targetId) {
      console.log('loadAllReviews: No agencyId available');
      return;
    }
    try {
      setLoadingAllReviews(true);
      console.log('Loading all reviews for agencyId:', targetId);
      const response = await userService.getAgencyReviewsById(targetId);
      console.log('Reviews response:', JSON.stringify(response, null, 2));
      if (response && response.success && response.data) {
        const reviewsData = response.data.reviews || response.data || [];
        console.log('Setting reviews:', reviewsData.length, 'reviews');
        setAllReviews(reviewsData);
      }
    } catch (err) {
      console.log('Error loading all reviews:', err.message || 'Unknown error');
      if (agencyData?.reviews) {
        setAllReviews(agencyData.reviews);
      }
    } finally {
      setLoadingAllReviews(false);
    }
  };

  const handleSubmitReview = async () => {
    if (!reviewComment.trim()) {
      showToast('Please enter a review comment', 'error');
      return;
    }

    // Check if user already has a review and we're not editing
    if (userExistingReview && !isEditingReview) {
      showToast('You have already reviewed this agency. You can edit your existing review.', 'error');
      return;
    }

    // Validate agencyId exists
    const targetAgencyId = agencyId || agencyData?.id;
    if (!targetAgencyId) {
      showToast('Agency ID not found. Please go back and try again.', 'error');
      return;
    }

    try {
      setSubmittingReview(true);
      const reviewData = {
        agency_id: targetAgencyId,
        review_type: starRating >= 4 ? 'positive' : 'negative',
        rating: starRating,
        comment: reviewComment.trim(),
      };

      console.log('Submitting review for agencyId:', targetAgencyId);
      const response = await userService.addAgencyReview(targetAgencyId, reviewData);
      if (response && response.success) {
        showToast(isEditingReview ? 'Your review has been updated!' : 'Your review has been submitted!', 'success');
        setReviewComment('');
        setStarRating(5);
        setIsEditingReview(false);
        setAddReviewModalVisible(false);
        // Reload agency profile and reviews
        console.log('Reloading agency profile after review submission...');
        await loadAgencyProfile(targetAgencyId);
        await loadAllReviews();
      } else {
        showToast(response?.message || 'Failed to submit review', 'error');
      }
    } catch (err) {
      console.log('Error submitting review:', err);
      showToast(err.message || 'Failed to submit review. Please try again.', 'error');
    } finally {
      setSubmittingReview(false);
    }
  };

  const handleViewAllReviews = () => {
    setAllReviewsModalVisible(true);
    loadAllReviews();
  };

  const handleAddOrEditReview = () => {
    if (userExistingReview) {
      // Edit existing review
      setIsEditingReview(true);
      setStarRating(userExistingReview.rating || 5);
      setReviewComment(userExistingReview.comment || '');
    } else {
      // Add new review
      setIsEditingReview(false);
      setStarRating(5);
      setReviewComment('');
    }
    setAddReviewModalVisible(true);
  };

  const handleCall = () => {
    const phone = agencyData?.phone || agencyData?.phone_number || '+91 9876543210';
    if (phone) {
      window.open(`tel:${phone}`);
    } else {
      showToast('Phone number not available for this agency', 'error');
    }
  };

  const toggleAbout = () => {
    setShowFullAbout(!showFullAbout);
  };

  const copyToClipboard = () => {
    const idToCopy = agencyData?.id || agencyId || profile.id;
    navigator.clipboard.writeText(idToCopy);
    showToast(`ID ${idToCopy} copied to clipboard`, 'success');
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <FaStar
          key={i}
          color={i <= rating ? '#FFC107' : '#D1D5DB'}
          size={14}
          style={{ marginRight: 2 }}
        />
      );
    }
    return stars;
  };

  // Get cover images from achievements or use defaults
  const getCoverImages = () => {
    const images = [];
    if (agencyData?.achievements && agencyData.achievements.length > 0) {
      agencyData.achievements.forEach(a => {
        if (a.image_url) images.push(a.image_url);
      });
    }
    if (agencyData?.banner_image) {
      images.unshift(agencyData.banner_image);
    }
    return images.length > 0 ? images : [profile.bannerImg]; // use profile banner as default
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    showToast("Form submitted ✅", 'success');
    setIsOpen(false);
  };

  // Save handler (updates state from modal)
  const handleSaveProfile = (updatedProfile, updatedAbout) => {
    setProfile(updatedProfile);
    setAbout(updatedAbout);
    setShowModal(false);
  };

  if (loading) {
    return (
      <div>
        <LeftNav />
        <div className="main-content" style={{ marginLeft: "250px",
    position: "absolute",top: "0px",
    width: "-webkit-fill-available" }}>
          <TopNav />
          <div className="p-3 d-flex justify-content-center align-items-center" style={{ minHeight: '400px', marginTop: '70px' }}>
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <LeftNav />
      <div className="main-content" style={{ marginLeft: "250px",
    position: "absolute",top: "0px",
    width: "-webkit-fill-available" }}>
        <TopNav />
        <div className="p-3">
          <div className="account-settings container-fluid px-4 py-3">
            <div className="account-card p-4">
              <div className="banner position-relative">
                <img
                  src={agencyData?.banner_image ? getFullImageUrl(agencyData.banner_image) : profile.bannerImg}
                  alt="banner"
                  className="banner-img img-fluid w-100 rounded"
                />
                <div className="profile-logo position-absolute">
                  <img src={agencyData?.avatar_url ? getFullImageUrl(agencyData.avatar_url) : profile.profileImg} alt="profile" />
                </div>
              </div>
              <div className="profile-info d-flex justify-content-between align-items-start">
                <div>
                  <h5 style={{color:"black"}}>{agencyData?.company_name || agencyData?.full_name || agencyData?.name || profile.name}</h5>


<p
  className="profile-location mb-2 mt-2"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "14px",
    color: "#374151",
    fontFamily: "Manrope, sans-serif",
  }}
>
  <img
    src={bluemap}
    alt="map"
    style={{ width: "16px", height: "16px", marginRight: "4px" }}
  />
  {agencyData?.city || profile.location}, {agencyData?.country || 'India'}
  <span
    style={{
      display: "flex",
      alignItems: "center",
      gap: "3px",
      marginLeft: "8px",
      color: "#FACC15", // yellow star color
      fontWeight: 600,
    }}
  >
    <FaStar size={14} />
    <span style={{ color: "#111827" }}>{agencyData?.average_rating > 0 ? agencyData.average_rating.toFixed(1) : (agencyData?.rating > 0 ? agencyData.rating.toFixed(1) : '0.0')}</span>
  </span>
</p>

                  <p className="profile-idexp mt-1">
                    ID : {agencyData?.id || agencyId || profile.id}
                    <button
                      onClick={copyToClipboard}
                      className="btn btn-link p-0 ms-2"
                      style={{fontSize: '12px'}}
                    >
                      <FaCopy size={14} color="#007AFF" />
                    </button>
                    <span className="ms-4">
                      <img
                        src={clock}
                        className="me-1 align-middle"
                        alt="clock"
                      />
                      {agencyData?.experience || profile.experience} Experience
                    </span>
                  </p>
                </div>
               <img
                 src={callIcon}
                 alt="call"
                 width="36"
                 height="36"
                 onClick={handleCall}
                 style={{cursor: 'pointer'}}
               />
              </div>

              <div className="about-card mt-4 p-3">
                <h6 className="profile-aboutme mt-2">About Us</h6>
                <p className="profile-abouttext small mb-0">
                  {showFullAbout
                    ? (agencyData?.about || agencyData?.description || about)
                    : ((agencyData?.about || agencyData?.description || about).substring(0, 100) + '...')}
                  <span
                    onClick={toggleAbout}
                    style={{color: '#5F4B8B', fontWeight: '600', cursor: 'pointer', marginLeft: '5px'}}
                  >
                    {showFullAbout ? ' less' : ' more'}
                  </span>
                </p>
                <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "20px",
        marginTop: "20px",
        fontFamily: "Manrope, sans-serif",
      }}
    >
      {/* Sales Card */}
      <div
        style={{
          background: "#F6F6FE",
          borderRadius: "12px",
          padding: "14px 30px",
          textAlign: "center",
          flex: 1,
        }}
      >
        <h4
          style={{
            color: "#3B82F6",
            fontWeight: 700,
            margin: 0,
            fontSize: "22px",
          }}
        >
          {agencyData?.sales_count || 0}
        </h4>
        <p
          style={{
            margin: 0,
            fontSize: "14px",
            color: "#555",
            fontWeight: 500,
          }}
        >
          Sales
        </p>
      </div>

      {/* Partnerships Card */}
      <div
        style={{
          background: "#F6F6FE",
          borderRadius: "12px",
          padding: "14px 30px",
          textAlign: "center",
          flex: 1,
        }}
      >
        <h4
          style={{
            color: "#6366F1",
            fontWeight: 700,
            margin: 0,
            fontSize: "22px",
          }}
        >
          {agencyData?.partnerships_count || 0}
        </h4>
        <p
          style={{
            margin: 0,
            fontSize: "14px",
            color: "#555",
            fontWeight: 500,
          }}
        >
          Partnerships
        </p>
      </div>

      {/* Revoked Card */}
      <div
        style={{
          background: "#F6F6FE",
          borderRadius: "12px",
          padding: "14px 30px",
          textAlign: "center",
          flex: 1,
        }}
      >
        <h4
          style={{
            color: "#4B5563",
            fontWeight: 700,
            margin: 0,
            fontSize: "22px",
          }}
        >
          {agencyData?.revoked_count || 0}
        </h4>
        <p
          style={{
            margin: 0,
            fontSize: "14px",
            color: "#555",
            fontWeight: 500,
          }}
        >
          Revoked
        </p>
      </div>
    </div>







              </div>




               <div
      style={{
       fontFamily: "Manrope, sans-serif",
    backgroundColor: "#fff",
    border: "1px solid #E5E7EB",
    borderRadius: "12px",
    padding: "20px",
    width: "100%",
    marginTop: "30px",
    display: "block",          // ✅ ensures margin-top works
    position: "relative",      // ✅ prevents margin collapsing
    zIndex: 1,

      }}
    >
      <h5
        style={{
          fontWeight: 700,
          fontSize: "16px",
          marginBottom: "16px",
        }}
      >
        Achievements
      </h5>

      <div
        style={{
          display: "flex",
          gap: "16px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {/* Show achievements only if available */}
        {agencyData?.achievements && agencyData.achievements.length > 0 ? (
          agencyData.achievements.map((achievement, index) => (
          <div
            key={achievement.id || index}
            style={{
              backgroundColor: "#F4F4F4",
              borderRadius: "12px",
              padding: "8px",
              textAlign: "center",
              width: "265px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
            }}
          >
            <img
              src={achievement.image_url ? getFullImageUrl(achievement.image_url) : (index % 2 === 0 ? frame : frame1)}
              alt="Achievement"
              style={{
                width: "100%",
                height: "120px",
                objectFit: "cover",
                borderRadius: "8px",
                marginBottom: "8px",
              }}
            />
            <p
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#000",
                margin: 0,
              }}
            >
              {achievement.title || "Achievement"}
            </p>
          </div>
        ))
        ) : (
          <div style={{
            textAlign: 'center',
            padding: '40px',
            color: '#6B7280',
            fontSize: '14px'
          }}>
            No achievements data added
          </div>
        )}
      </div>
    </div>
    <div
      style={{
        border: "1px solid #E5E7EB",
        borderRadius: "12px",
        backgroundColor: "#fff",
        padding: "20px",
        fontFamily: "Inter, Arial, sans-serif",
        color: "#111827",
        marginTop: "30px",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h4 style={{ margin: 0, fontWeight: 600, fontSize: "16px" }}>
          Builder Ratings & Reviews
        </h4>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <FaStar color="#FACC15" size={18} />
          <span style={{ fontWeight: 600, fontSize: "15px" }}>
            {agencyData?.average_rating > 0 ? agencyData.average_rating.toFixed(1) : '0.0'}
          </span>
          <span style={{ color: "#6B7280", fontSize: "14px" }}>({agencyData?.total_reviews || 0})</span>
        </div>
      </div>

      {/* Reviews */}
      {agencyData?.reviews && agencyData.reviews.length > 0 ? (
        agencyData.reviews.slice(0, 3).map((review, index) => (
        <div
          key={index}
          style={{
            border: "1px solid #E5E7EB",
            borderRadius: "10px",
            padding: "18px",
            marginBottom: "15px",
            backgroundColor: "#fff",
            boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <img
              src={review.reviewer_avatar ? getFullImageUrl(review.reviewer_avatar) : (review.image || frame)}
              alt={review.reviewer_name || review.name}
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                objectFit: "cover",
                marginRight: "10px",
              }}
            />
            <div style={{ flexGrow: 1 }}>
              <h6
                style={{
                  margin: 0,
                  fontWeight: 600,
                  fontSize: "15px",
                  color: "#111827",
                }}
              >
                {review.reviewer_name || review.name}
              </h6>
            </div>

            <div style={{ display: "flex", gap: "2px" }}>
              {Array.from({ length: 5 }).map((_, i) =>
                i < review.rating ? (
                  <FaStar key={i} color="#FACC15" size={15} />
                ) : (
                  <FaRegStar key={i} color="#D1D5DB" size={15} />
                )
              )}
            </div>
          </div>

          <p
            style={{
              fontSize: "14px",
              color: "#374151",
              lineHeight: "1.6",
              marginBottom: "10px",
            }}
          >
            {review.comment || review.text}
          </p>

          <p style={{ fontSize: "12px", color: "#9CA3AF", margin: 0 }}>
            {formatDate(review.created_at) || review.date}
          </p>
        </div>
        ))
      ) : (
        <div style={{
          textAlign: 'center',
          padding: '40px',
          color: '#6B7280',
          fontSize: '14px',
          border: '1px solid #E5E7EB',
          borderRadius: '10px',
          backgroundColor: '#F9FAFB'
        }}>
          No reviews data added
        </div>
      )}

      {/* Action Buttons */}
      <div style={{display: 'flex', gap: '10px', marginTop: '10px'}}>
        <button
          onClick={handleViewAllReviews}
          style={{
            flex: 1,
            border: "1px solid #6366F1",
            borderRadius: "8px",
            padding: "10px 0",
            color: "#6366F1",
            background: "#fff",
            fontWeight: 600,
            fontSize: "14px",
            cursor: "pointer",
          }}
        >
          View All Reviews
        </button>
        <button
          onClick={handleAddOrEditReview}
          style={{
            flex: 1,
            border: "none",
            borderRadius: "8px",
            padding: "10px 0",
            color: "#fff",
            background: "#6366F1",
            fontWeight: 600,
            fontSize: "14px",
            cursor: "pointer",
          }}
        >
          {userExistingReview ? 'Edit Review' : 'Add Review'}
        </button>
      </div>
    </div>



            </div>
          </div>
        </div>
      </div>

      {/* Add Review Modal */}
      {isAddReviewModalVisible && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{isEditingReview ? 'Edit Review' : 'Add Review'}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setAddReviewModalVisible(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label fw-semibold">Rate your experience</label>
                  <div className="d-flex justify-content-center gap-2 py-2">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <button
                        key={star}
                        type="button"
                        className="btn p-1"
                        onClick={() => setStarRating(star)}
                      >
                        <FaStar
                          size={32}
                          color={star <= starRating ? '#FFD700' : '#D1D5DB'}
                        />
                      </button>
                    ))}
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Your Review</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    placeholder="Share your experience with this agency..."
                    value={reviewComment}
                    onChange={(e) => setReviewComment(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setAddReviewModalVisible(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmitReview}
                  disabled={submittingReview}
                >
                  {submittingReview ? (isEditingReview ? 'Updating...' : 'Submitting...') : (isEditingReview ? 'Update Review' : 'Submit Review')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* View All Reviews Modal */}
      {isAllReviewsModalVisible && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">All Reviews</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setAllReviewsModalVisible(false)}
                ></button>
              </div>
              <div className="modal-body">
                {/* Review Stats */}
                <div className="text-center bg-light rounded p-3 mb-3">
                  <FaStar size={24} color="#FFC107" />
                  <div className="h4 mt-2 mb-1">
                    {agencyData?.average_rating > 0 ? agencyData.average_rating.toFixed(1) : '0.0'}
                  </div>
                  <small className="text-muted">{agencyData?.total_reviews || 0} Reviews</small>
                </div>

                {/* Reviews List */}
                <div style={{maxHeight: '400px', overflowY: 'auto'}}>
                  {loadingAllReviews ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
                    </div>
                  ) : (agencyData?.reviews && agencyData.reviews.length > 0) || allReviews.length > 0 ? (
                    (allReviews.length > 0 ? allReviews : agencyData.reviews).map((review, index) => (
                      <div key={review.id || index} className="border rounded p-3 mb-3">
                        <div className="d-flex align-items-center mb-2">
                          <img
                            src={review.reviewer_avatar ? getFullImageUrl(review.reviewer_avatar) : frame}
                            alt={review.reviewer_name || 'Reviewer'}
                            style={{
                              width: '40px',
                              height: '40px',
                              borderRadius: '50%',
                              objectFit: 'cover',
                              marginRight: '10px'
                            }}
                          />
                          <div className="flex-grow-1">
                            <h6 className="mb-1">{review.reviewer_name || 'Anonymous'}</h6>
                            <div className="d-flex">
                              {renderStars(review.rating || 0)}
                            </div>
                          </div>
                        </div>
                        <p className="mb-2">{review.comment || 'No comment provided'}</p>
                        <small className="text-muted">{formatDate(review.created_at)}</small>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-4">
                      <div className="h5">No reviews yet</div>
                      <p className="text-muted">Be the first to review this agency!</p>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary w-100"
                  onClick={() => {
                    setAllReviewsModalVisible(false);
                    setTimeout(() => setAddReviewModalVisible(true), 300);
                  }}
                >
                  Add Your Review
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Toast Notifications */}
      <Toaster
        show={toast.show}
        message={toast.message}
        type={toast.type}
        duration={5}
        onClose={hideToast}
      />
    </div>
  );
}